import React from 'react';
import { Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function FinalCTA() {
  return <section className="bg-[#2DB8E0] text-white py-16 sm:py-20 text-center" data-id="element-80" data-mp="3ud6zpjgqgoct">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81" data-mp="c6ivdvtic587">
        <h2 className="font-display italic text-4xl sm:text-5xl leading-tight mb-5" data-id="element-82" data-mp="c4o6y7j11uzd">
          Ready for a Roof That's Built to Last?
        </h2>
        <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-83" data-mp="m4f5qlemew59">
          Free inspection. Upfront pricing.{' '}
          <span className="font-bold" data-id="element-84" data-mp="h52dfl4zcwva">$500 off your replacement</span> when you
          book this month.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-85" data-mp="vtykbevaw3ub">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-white text-[#1a9cc4] hover:bg-slate-50 font-bold text-lg px-8 py-4 rounded-full transition-colors shadow-lg" data-id="element-86" data-mp="qwzuh8io6j1x">
            <span className="mr-2" data-id="element-87" data-mp="zua6wx784e8f">—</span>
            Get a Quote Now!
            <span className="ml-2" data-id="element-88" data-mp="2c5y85iig49b9">—</span>
          </a>
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center justify-center gap-2 bg-[#1a2332] hover:bg-[#2d3a4d] text-white font-bold text-lg px-7 py-4 rounded-full transition-colors shadow-lg" data-id="element-89" data-mp="2h3hn6kmywq49">
            <Phone className="w-5 h-5" data-id="element-90" data-mp="2r38ksv6trl8k" /> Call {PHONE}
          </a>
        </div>
      </div>
    </section>;
}